
<mat-list class="w-full h-full sm:w-1/2 sm:m-8 grid gap-5
    max-sm:divide-y max-sm:divide-2">
    <mat-list-item *ngIf="isInternal" class="charity-list-item"
        (click)="onCharityCheck()">
        <div mat-line class="charity-item-title"> Charitable Contributions</div>
    </mat-list-item>
    <mat-list-item *ngIf="hasRole('ADMIN')" routerLink="matching-gift"
        class="charity-list-item">
        <div mat-line class="charity-item-title"> Matching Gift</div>
    </mat-list-item>
    <mat-list-item *ngIf="isFormCGExpired" routerLink="community-grant"
        class="charity-list-item">
        <div mat-line class="charity-item-title"> Community Grants Application</div>
        <div mat-line *ngIf="formCGConfig && formCGConfig?.startDate != null">
            (Accessible from
            {{formCGConfig?.startDate| date: 'MM-dd-yyyy'}} to
            {{formCGConfig.endDate | date: 'MM-dd-yyyy'}})
        </div>
    </mat-list-item>
    <mat-list-item *ngIf="isFormESExpired" routerLink="event-sponsorship"
        class="charity-list-item">
        <div mat-line class="charity-item-title" class="charity-item-title">
            Event Sponsorship Application</div>
        <div mat-line *ngIf="formESConfig && formESConfig?.startDate != null">
            (Accessible from
            {{formESConfig?.startDate| date: 'MM-dd-yyyy'}} to
            {{formESConfig.endDate | date: 'MM-dd-yyyy'}})
        </div>
    </mat-list-item>
    <mat-list-item *ngIf="isFormPPExpired" routerLink="plant-planet"
        class="charity-list-item">
        <div mat-line class="charity-item-title"> Plant for the Planet Matching
            Grant Program
        </div>
        <div mat-line *ngIf="formPPConfig && formPPConfig?.startDate != null">
            (Accessible from
            {{formPPConfig?.startDate| date: 'MM-dd-yyyy'}} to
            {{formPPConfig.endDate | date: 'MM-dd-yyyy'}})
        </div>
    </mat-list-item>
</mat-list>
<!-- <div class="content" fxLayout="row" fxLayout.lt-md="column" [@routeAnimation]="true">
    <div fxLayout="column" fxLayoutGap="16px" fxFlex="40%" fxFlexFill>

        <div *ngIf="isInternal" fxLayout="column">
            <mat-card class="matcardButton" (click)="onCharityCheck()">
                Charitable Contribution
            </mat-card>
        </div>

        <div *ngIf="hasRole('ADMIN')" fxLayout="column">
            <mat-card class="matcardButton" routerLink="matching-gift">
                Matching Gift
            </mat-card>
        </div>

        <div *ngIf=" isFormCGExpired" fxLayout="column" fxLayoutGap="5px">
            <mat-card class="matcardButton" routerLink="community-grant">
                Community Grants Application
            </mat-card>
            <mat-hint *ngIf="formCGConfig?.startDate != null"> (Accessible from
                {{formCGConfig?.startDate| date: 'MM-dd-yyyy'}} to {{formCGConfig.endDate | date: 'MM-dd-yyyy'}})
            </mat-hint>
        </div>

        <div *ngIf=" isFormESExpired" fxLayout="column" fxLayoutGap="5px">
            <mat-card class="matcardButton" routerLink="event-sponsorship">
                Event Sponsorship Application
            </mat-card>
            <mat-hint *ngIf="formESConfig?.startDate != null"> (Accessible from
                {{formESConfig?.startDate| date: 'MM-dd-yyyy'}} to {{formESConfig.endDate | date: 'MM-dd-yyyy'}})
            </mat-hint>
        </div>

        <div *ngIf="isFormCIExpired" fxLayout="column" fxLayoutGap="5px">
            <mat-card class="matcardButton" routerLink="community-investment">
                Community Investment Funding Application
            </mat-card>
            <mat-hint *ngIf="formCIConfig?.startDate != null"> (Accessible from
                {{formCIConfig?.startDate| date: 'MM-dd-yyyy'}} to {{formCIConfig.endDate | date: 'MM-dd-yyyy'}})
            </mat-hint>

        </div>

        <div *ngIf="isFormFOExpired" fxLayout="column" fxLayoutGap="5px">
            <mat-card class="matcardButton" routerLink="foundation">
                LG&E and KU Foundation Application
            </mat-card>
            <mat-hint *ngIf="formFOConfig?.startDate != null"> (Accessible from
                {{formFOConfig?.startDate| date: 'MM-dd-yyyy'}} to {{formFOConfig.endDate | date: 'MM-dd-yyyy'}})
            </mat-hint>
        </div> 

        <div *ngIf=" isFormPPExpired" fxLayout="column" fxLayoutGap="5px">
            <mat-card class="matcardButton" routerLink="plant-planet">
                Plant for the Planet Matching Grant Program
            </mat-card>
            <mat-hint *ngIf="formPPConfig?.startDate != null"> (Accessible from
                {{formPPConfig?.startDate| date: 'MM-dd-yyyy'}} to {{formPPConfig.endDate | date: 'MM-dd-yyyy'}})
            </mat-hint>
        </div>

    </div>

    <div fxLayout="column">
        <router-outlet></router-outlet>
    </div>

</div> -->